import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import axios from "../../API/axios";
import CompanyImg from '../../assets/images/khoj-images/image 484.png';
import moment from "moment";
Job03.propTypes = {};

function Job03() {
  const token = localStorage.getItem('token')
  // ...............................All Job List.......................................

  const [jobList, setjobList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getAlljobList = (page) => {
    const data =
    {
      pageNumber: page,
      pageSize: 10,
    };
    
    axios
      .post(`/Job/GetAll`, data)
      .then((response) => {

        const res = response.data.responseData.jobsList;
        console.log("getAlljobList", response.data.responseData.jobsList);
        setjobList(res);
        setIsLoading(false);

      })
      .catch((error) => {
        console.log("error", error)
      });
  };

  useEffect(() => {
    getAlljobList(); // Initial fetch on mount
  }, []);

  // ...............................All Jobs List.......................................

  return (
    <section className="container topJobsHome">
      {/* <Tabs className="wrap-testimonials over-flow-hidden tf-tab"> */}
      <div className="container">
        <div className="tf-title style-2">
          <div className="group-title">
            <h1>Featured Jobs</h1>
            <p>Find the job that's perfect for you. about 800+ new jobs everyday</p>
          </div>

        </div>
        <div className="row content-tab wow fadeInUp jobs-tab">
          {jobList.slice(0, 4).map((data) => (
            <div key={data.id} className="col-lg-6 d-flex align-items-stretch Candidate-Featured-Jobs-Cards">
              <div className="features-job w-100">
                <div className="job-archive-header">
                  <div className="inner-box">
                    <div className="logo-company">
                      <img src={data.compImage} alt="jobtex" />
                      {/* <img src={data.img} alt="jobtex" /> */}
                    </div>
                    <div className="box-content">
                      <h4>
                        {token === null ? data.compName : <Link to={`/jobDetails/${data.jobId}`} >{data.compName}</Link>}
                      </h4>
                      <h3>
                        {token === null ? data.title : <Link to={`/jobDetails/${data.jobId}`}> {data.title} </Link>}

                      </h3>
                      <ul className="ps-0">
                        <li>
                          <span className="icon-map-pin"></span>
                          &nbsp;
                          {data.cityName}
                        </li>
                        <li>
                          <span className="icon-calendar"></span>
                          &nbsp;
                          {/* {data.creationTime} */}
                          {moment
                            .utc(data.creationTime)
                            .local()
                            .format("DD MMMM YYYY")}
                        </li>
                      </ul>
                      {/* <span className="icon-heart"></span> */}
                    </div>
                  </div>
                </div>
                <div className="job-archive-footer">
                  <div className="job-footer-left">
                    <ul className="job-tag Job-Footer-Small-Button">
                      <li>
                        <Link to="#/">{data.jbTypName}</Link>
                      </li>
                      <li>
                        <Link to="#/">{data.workLevelTypename}</Link>
                      </li>
                      <li>
                        <Link to="#/">{data.workLocationTypeName}</Link>
                      </li>
                      <li>
                        <Link to="#/">{data.designationName}</Link>
                      </li>
                    </ul>
                    {/* <div className="star">
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                        </div> */}
                  </div>
                  <div className="job-footer-right">
                    <div className="price">
                      {/* <span className="icon-dolar1"></span> */}
                      <p className="mb-0">
                        {data.currency} {data.minSalary} / {data.salaryTypeName}
                        <span className="year"></span>
                      </p>
                    </div>
                    <p className="days mb-0">{data.apply}</p>
                  </div>
                </div>
                {/* <Link
                      to="/jobDetails"
                      className="jobtex-link-item"
                      tabIndex="0"
                    ></Link> */}
              </div>
            </div>
          ))}
          {/* </TabPanel> */}
          {/* </div>
            </div>
            <div className="swiper-pagination tes-bullet style-1"></div>
          </div> */}
          <div className="d-flex justify-content-center mt-2">
            <div className="khojPrimaryBtn" style={{ width: '192px', height: '50px' }}>
              <Link to="/SearchJobs" className="" >See More Jobs</Link>
            </div>
          </div>
        </div>
      </div>
      {/* </Tabs> */}
    </section>
  );
}

export default Job03;
